import classNames from 'classnames';
import React from 'react';

import { Image } from '../Image';

type Props = {
  background: StoryblokImage;
  className?: string;
};

export const ArticleBackground: React.FC<Props> = ({
  background,
  className = 'absolute',
}) => {
  return (
    <div
      className={classNames(className, 'left-0 right-0 top-0 z-0 w-full')}
      style={{
        maskImage: 'linear-gradient(to bottom, #000000 0%, transparent 100%)',
      }}
    >
      <div className="absolute bottom-0 left-0 right-0 top-0 z-40 bg-gradient-to-b from-black/40" />
      <div className="absolute bottom-0 left-0 right-0 top-0 z-20 bg-black/40 backdrop-blur-lg" />
      <Image
        alt={background.alt}
        className="z-10 contrast-150"
        eagerLoading
        focus={background.focus}
        size={{
          sm: { ratio: '9/16', span: 12 },
          md: { ratio: '4/3', span: 12 },
          lg: { ratio: '5/3', span: 12 },
        }}
        src={background.filename}
        width={384}
      />
    </div>
  );
};
